module.exports = __webpack_public_path__ + "static/media/log-history.c63b30d0.svg";